import request from 'app-self-support-order/utils/request'
import api from 'app-self-support-order/common/api/group-msg'

// 创建群发
export async function createMsg(payload) {
    return request(api.createMsg.url, {
        method: api.createMsg.type,
        body: payload.body,
    })
}

// 计算过滤后的群发客户数量
export async function getFilterCustomerCount(payload) {
    return request(api.getFilterCustomerCount.url, {
        method: api.getFilterCustomerCount.type,
        body: payload.body,
    })
}
